import React, { Component } from 'react';
import {
  Row, Col,
} from 'antd';
import {
  Modal, Input,
} from 'view/common';
import {
  NewProject,
  Why,
} from 'view/screens';
import SEARCH from 'assets/img/search.svg';
import SEARCH_DARK from 'assets/img/black/search.svg';
import ProjectItem from './ProjectItem';
import projects from './dummy.json';
import './style.scss';
import './style_dark.scss';

class ProjectsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addressSearchValue: '',
      projectTitle: '',
      addressList: [],
    };
  }

  componentDidMount() {
    this.dragOver = window.addEventListener('dragover', (e) => {
      e.preventDefault();
    }, false);
    this.drop = window.addEventListener('drop', (e) => {
      e.preventDefault();
    }, false);
  }

  componentWillUnmount() {
    window.removeEventListener('dragover', this.dragOver, false);
    window.removeEventListener('drop', this.drop, false);
  }

  handleInput = (event) => {
    const { name, value } = event.target;
    this.setState(p => ({
      [name]: value,
      dropdownVisible: !!(name === 'addressSearchValue' && p.addressSearchValue.length < value.length),
    }));
  };

  newProjectSubmit = () => {
    // create a project here
    this.projectModal.close();
  };

  handleSelectOption = (option) => {
    // handle predefined filters here
    this.whyModal.close();
    return option;
  };

  render() {
    const { isDarkTheme } = this.props;
    const dropdownOptions = [
      { title: '123 C St.Corona, 92883, CA', data: {} },
      { title: '123 C St.Corona, 92883, CA', data: {} },
      { title: '123 C St.Corona, 92883, CA', data: {} },
      { title: '123 C St.Corona, 92883, CA', data: {} },
      { title: '123 C St.Corona, 92883, CA', data: {} },
    ];

    return (
      <div className="project_list">
        <div className="header">
          <h1>My Projects</h1>
          <div className="rightBlock">
            <Input
              iconSrc={isDarkTheme ? SEARCH_DARK : SEARCH}
              style={{ width: '280px', margin: '0 27px' }}
              inputProps={{
                placeholder: 'Search Project',
              }}
            />
            <button type="button" onClick={() => this.projectModal.open()}>New Project</button>
          </div>
        </div>
        <div className="projects_wrapper">
          <Row gutter={40}>
            {projects.map(project => (
              <Col span={8} key={project.id}>
                <ProjectItem data={project} isDarkTheme={isDarkTheme} />
              </Col>
            ))}
          </Row>
        </div>
        <Modal ref={(r) => {
          this.projectModal = r;
        }}
        >
          <NewProject
            addressSearchValue={this.state.addressSearchValue}
            projectTitle={this.state.projectTitle}
            addressList={this.state.addressList}
            handleInput={this.handleInput}
            submit={this.newProjectSubmit}
            cancel={() => this.projectModal.close()}
            dropdownOptions={dropdownOptions}
            isDarkTheme={isDarkTheme}
          />
        </Modal>
        <Modal ref={(r) => {
          this.whyModal = r;
        }}
        >
          <Why handleSelectOption={option => this.handleSelectOption(option)} />
        </Modal>
      </div>
    );
  }
}

export default ProjectsList;



// WEBPACK FOOTER //
// ./src/view/screens/ProjectsList/ProjectsList.jsx